import React, { useState, useEffect } from 'react';
import { useNavigation } from '../../context/NavigationContext';
import { BringzzIcon, BringzzRadio, BringzzRadioList, BringzzBottomDrawer } from "@bringzz/components";
import classnames from 'classnames';
import './navbar.css';
import { useAuth } from 'context/AuthContext';
import { returnMenuList, handleMenuNavigation } from 'utils';
import { useTranslation } from 'react-i18next';

const state = {
	checked: <div></div>,
	unChecked: <div></div>
};

const Navbar = ({ safeInsets = { bottom: 0 } }) => {
	const { navigate, isActive } = useNavigation();
	const { user } = useAuth();
	const { t } = useTranslation();
	if (!user) return null;
	const [pickerDrawerOpened, setPickerDrawerOpened] = useState(null);
	const [isIPhone, setIsIPhone] = useState(false);

	useEffect(() => {
		// Detect iPhone devices using user agent
		const userAgent = navigator.userAgent || navigator.vendor || window.opera;
		const isiPhone = /iPhone/i.test(userAgent);
		setIsIPhone(isiPhone);
	}, []);

	const handlePickerClick = async choice => {
		if (choice == "external_link") {
			navigate('/posts/add', {
				state: {type: 2}
			})
		} else if (choice == "product_post") {
			navigate('/posts/add', {
				state: {type: 3}
			})
		} else if (choice == "article_post") {
			navigate('/posts/add', {
				state: {type: 1}
			})
		}
	}

	const navbarStyle = {};

	return (
		<div
			className='navbar-container bg-white flex justify-around items-center shadow-top z-30 text-sm'
		>
			{returnMenuList(user.userRole).map((item, index) => {
				const active = isActive(item.url);

				return (
					<div
						key={index}
						onClick={() => handleMenuNavigation(item, navigate, setPickerDrawerOpened)}
						className={classnames(
							'flex flex-col items-center cursor-pointer',
							active ? 'text-black' : 'text-slate-500'
						)}
					>
						<BringzzIcon icon={item.icon} folder={item.folder} size='24' />
						{active ? (
							<span className='text-magic-lilac text-[7px] h-2'>&#9679;</span>
						) : (
							<span className='text-magic-lilac text-[7px] h-2'></span>
						)}
					</div>
				);
			})}

			<BringzzBottomDrawer
				isOpen={pickerDrawerOpened}
				title={t('component.navbar.select_post_type')}
				close={() => setPickerDrawerOpened(false)}
			>
				<div className='px-4 py-6'>
					<BringzzRadioList
						state={state}
						className='rounded-xl w-full text-center'
						onChange={choice => {
							handlePickerClick(choice);
							setPickerDrawerOpened(false);
						}}
					>
						<BringzzRadio
							value='external_link'
							className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400 flex'
						>
							<div>{t('component.navbar.external_link')}</div>
						</BringzzRadio>
						<BringzzRadio
							value='product_post'
							className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400'
						>
							<div>{t('component.navbar.product_post')}</div>
						</BringzzRadio>
						<BringzzRadio
							className='p-2 py-4 hover:bg-slate- border-1 border-t border-gray-400'
							value='article_post'
						>
							<div>{t('component.navbar.article_post')}</div>
						</BringzzRadio>
					</BringzzRadioList>
				</div>
			</BringzzBottomDrawer>
		</div>
	);
};

export default Navbar;
